import { useMemo } from 'react'

import { useRequest } from 'ahooks'
import { createStyles } from 'antd-style'

import { queryHelpCatalogueTreeWithDocApi } from '@eastcoal/api/content/helpCatalogueMall/queryHelpCatalogueTreeWithDoc'

import { HelpCatalogueCode } from '@eastcoal/shared/enums/HelpCatalogueCode'

import { TradeSessionDetailCard } from '../../DetailCard'

import { FlowIntroduceColumn } from './Column'
import { FlowIntroduceDivider } from './Divider'

const useStyles = createStyles(
  ({ token }, { columnLen }: { columnLen: number }) => ({
    container: {
      flex: 1,
      display: 'grid',
      alignItems: 'start',
      gridTemplateColumns: `repeat(${columnLen}, 1fr)`,
      columnGap: token.paddingMD,
      rowGap: token.paddingMD
    }
  })
)

const staticColumns = [
  {
    catalogue: '流程说明',
    divider: <FlowIntroduceDivider type='line' />,
    articles: [
      {
        name: '更多说明',
        // TODO: 帮助中心的地址
        url: '/support',
        prefixIcon: false
      }
    ]
  }
]

export const FlowIntroduceCard = () => {
  const { data } = useRequest(queryHelpCatalogueTreeWithDocApi, {
    manual: false,
    defaultParams: [
      {
        parentCode: HelpCatalogueCode.AUCTION_FLOW
      },
      {
        silence: true
      }
    ]
  })

  const columns = useMemo(() => {
    const dynamicColumns = data
      ? data.map(({ name, children = [] }) => ({
          catalogue: `${name}`,
          divider: <FlowIntroduceDivider type='arrow' />,
          articles: children
            .filter(item => item.doc)
            .map(({ id, name }) => ({ name, id, prefixIcon: true }))
        }))
      : undefined
    return dynamicColumns
      ? [...staticColumns, ...dynamicColumns]
      : staticColumns
  }, [data])

  const { styles } = useStyles({ columnLen: columns.length })

  return (
    <TradeSessionDetailCard
      classNames={{
        body: styles.container
      }}
    >
      {columns.map((item, index) => {
        return (
          <FlowIntroduceColumn
            key={item.catalogue}
            articles={item.articles}
            catalogue={item.catalogue}
            index={index}
          />
        )
      })}
    </TradeSessionDetailCard>
  )
}
